/* eslint-disable @typescript-eslint/no-explicit-any */
import ImageContent from '@apps/components/ImageContent';
import { getDateSlug } from '@apps/utils/get-date-slug';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button, Stack } from '@mui/material';
import placeholderImage from '@stack/assets/images/empty_placeholder.jpg';
import { TitleDivider } from '@stack/ui/components';
import { redirect } from '@webbyx/next-js';
import { toLower } from 'lodash';
import chunk from 'lodash/chunk';

import { AuthorNewsListingProps } from './props';
import { ContentWrapper, InnerContentWrapper, SectionWrapper } from './styles';
/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CarNewsListing: React.FC<AuthorNewsListingProps> = (props) => {
  const { data, webView = false, loading = false } = props;
  // ======================= HOOKS

  // ======================= STATE
  const remainRead = data;
  const chunkData = chunk(remainRead, 20);

  // ======================= API

  // ======================= EVENTS
  const getPostHref = (post: any) => {
    if (!post?.post_title) return;
    const dateSlug = getDateSlug(post.post_created);
    return webView
      ? `/webview/${dateSlug}/${toLower(post?.post_slug)}`
      : `/${dateSlug}/${toLower(post?.post_slug)}`;
  };

  // ======================= VARIABLES

  // ======================= LOADING VIEWS
  if (loading)
    return (
      <SectionWrapper>
        <ContentWrapper>
          {Array.from({ length: 40 }).map((rd: any, index) => {
            return (
              <InnerContentWrapper
                className="list-item custom-list-border"
                key={index}
              >
                <ImageContent
                  title={''}
                  footerText={''}
                  imagePosition="top"
                  tabletImagePosition="top"
                  simpleMobileView={true}
                  titleClass="custom-text-xl"
                  descriptionLine={3}
                  simpleMbView={true}
                  loading={loading}
                  webView={webView}
                  imageProps={{
                    src: '',
                    width: 216,
                    height: 130,
                    alt: '',
                  }}
                />
              </InnerContentWrapper>
            );
          })}
        </ContentWrapper>
      </SectionWrapper>
    );

  // ======================= VIEWS
  return (
    <SectionWrapper>
      <TitleDivider title="Related News" paddingBlock="0px" />

      <Stack gap="30px">
        {chunkData[0] && (
          <ContentWrapper
            style={{
              minHeight: loading ? '70vh' : 'unset',
            }}
          >
            {chunkData[0].map((rd: any, index) => {
              return (
                <InnerContentWrapper
                  className="list-item custom-list-border"
                  key={index}
                >
                  <ImageContent
                    title={rd.post_title}
                    titleSlug={rd?.post_slug}
                    description={rd.post_short_description}
                    badgeLabel={rd?.category_name}
                    footerText={rd?.post_created}
                    imageProps={{
                      src: rd?.post_thumbnail_id || placeholderImage.src,
                      width: 230,
                      height: 130,
                      alt: rd?.post_title,
                      loading: 'lazy',
                      priority: false,
                      fetchPriority: 'auto',
                    }}
                    imagePosition="top"
                    tabletImagePosition="top"
                    mobileImagePostion="top"
                    maxImageWidth={'100%'}
                    author={rd?.post_author}
                    authorAvatar={rd?.post_author_profile_image}
                    authorEmail={rd?.post_author_username}
                    titleClass="custom-text-xl"
                    descriptionLine={3}
                    href={getPostHref(rd)}
                    loading={loading}
                    webView={webView}
                    hideDescription={true}
                    authorImageProps={{
                      loading: 'lazy',
                      fetchPriority: 'low',
                      priority: false,
                      alt: rd?.post_author || '',
                    }}
                  />
                </InnerContentWrapper>
              );
            })}
          </ContentWrapper>
        )}

        <Button
          sx={{
            color: 'text.primary',
            fontSize: 16,
            fontWeight: 700,
            textTransform: 'capitalize',
            '&:hover ': {
              backgroundColor: 'transparent !important',
            },
          }}
          disableRipple
          onClick={() => redirect({}, '', 'push')}
          endIcon={
            <ArrowForwardIcon
              sx={{
                color: '#1E242F',
                width: 20,
                height: 20,
                ml: -0.5,
              }}
            />
          }
        >
          Show More
        </Button>
      </Stack>
    </SectionWrapper>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default CarNewsListing;
